import {LangKeys} from "locales/i18n";

export default {
   [LangKeys.en]: {
       title: "Store | Pumpkin Meet",
       description: "Pumpkin is all you need. A utility currency which you can purchase, earn, and spend to achieve your biggest dating goals.",
   },
}